import { render, staticRenderFns } from "./hero-section.vue?vue&type=template&id=4b66b01e&scoped=true"
import script from "./hero-section.vue?vue&type=script&lang=ts"
export * from "./hero-section.vue?vue&type=script&lang=ts"
import style0 from "./hero-section.vue?vue&type=style&index=0&id=4b66b01e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66b01e",
  null
  
)

export default component.exports